import type { IMasterDataProductPriceRepository } from "@src/domain/repositories/masterData";
import type { GetMasterDataProductPriceHistoryDTO } from "@src/domain/dto/masterData";

export class GetMasterDataProductPriceHistoryUseCase {
  private readonly repository: IMasterDataProductPriceRepository;

  constructor(repository: IMasterDataProductPriceRepository) {
    this.repository = repository;
  }

  execute(params: GetMasterDataProductPriceHistoryDTO) {
    return this.repository.getProductPriceHistory(params);
  }
}
